/// <reference path="../Lognotes/LognotesGrid.ts" />

namespace Nobox.CRM {

    import fld = LognotesRow.Fields;

    @Serenity.Decorators.registerClass()
    export class GroupLogGrid extends LognotesGrid {
        protected getDialogType() { return LognotesDialog; }

        constructor(container: JQuery) {
            super(container);
        }

        protected initEntityDialog(itemType, dialog) {
            super.initEntityDialog(itemType, dialog);
            Serenity.SubDialogHelper.cascade(dialog, this.element.closest('.ui-dialog'));
        }

        protected addButtonClick() {
            this.editItem({ IdModul: this.groupId, Type: this.type, NmMenu: this.menu });
        }


        protected getPersistanceStorage(): Serenity.SettingStorage {
            return window.localStorage;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this.groupId;
        }

        private _GroupID: string;
        private _Menu: string;
        private _Type: string;

        get groupId() {
            return this._GroupID;
        }
        get menu() {
            return this._Menu;
        }
        get type() {
            return this._Type;
        }
        protected getButtons() {
            var btn = super.getButtons();
            btn[0].cssClass = "lognotes";
            return btn;
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            var $this = this;
            if (this.type == "log") {
                $this.element.find(".lognotes").addClass("add-note");
                $(".add-note").remove();
            }
            //request.ColumnSelection = 1;
            request.EqualityFilter.IdModul = this.groupId;
            request.EqualityFilter.Type = this.type;
            request.EqualityFilter.NmMenu = this.menu;
        }
        //protected getColumns(): Slick.Column[] {
        //    var columns = super.getColumns();
        //    console.log(this.type,"columns")
        //    if (this.type == "note") {
        //        Q.first(columns, x => x.field == fld.Comment).format = ctx => `<a href="#NoBoxCRM-GroupLog/${ctx.item.Id}" data-item-type="Nobox.GroupLog" data-item-id="${ctx.item.Id}" class="s-EditLink s-NoBoxCRM-GroupLogLink">${ctx.value}</a>`;
        //    }
        //    Q.first(columns, x => x.field == fld.Comment).format = ctx => `<a href="#NoBoxCRM-GroupLog/${ctx.item.Id}" data-item-type="Nobox.GroupLog" data-item-id="${ctx.item.Id}" class="s-EditLink s-NoBoxCRM-GroupLogLink">${ctx.value}</a>`;
        //    return columns;
        //}
        set groupId(value: string) {
            if (this._GroupID !== value) {
                this._GroupID = value;
                this.refresh();
            }
        }
        set menu(value: string) {
            if (this._Menu !== value) {
                this._Menu = value;
                this.refresh();
            }
        }
        set type(value: string) {
            if (this._Type !== value) {
                this._Type = value;
                this.refresh();
            }
        }
        protected getViewOptions() {
            let opt = super.getViewOptions();
            opt.rowsPerPage = 20;
            return opt;
        }
        protected getPagerOptions() {
            let opt = super.getPagerOptions();
            opt.rowsPerPageOptions = [10, 20, 50, 100, 500, 1000];
            return opt;
        }
    }
}